import { render, staticRenderFns } from "./PointsDetail.vue?vue&type=template&id=2cd2a154&scoped=true"
import script from "./PointsDetail.vue?vue&type=script&lang=js"
export * from "./PointsDetail.vue?vue&type=script&lang=js"
import style0 from "./PointsDetail.vue?vue&type=style&index=0&id=2cd2a154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2a154",
  null
  
)

export default component.exports